import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { AppsService } from "../../commons/services/applications.service";
import { AnchorUISref, UISref } from "@uirouter/angular";

@Component({
  selector: 'op-apps-toggle',
  templateUrl: "./opAppsToggle.view.html",
  styleUrl: "./opAppsToggle.style.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnchorUISref, UISref]
})
export class OpAppsToggle {

  private readonly _appsService = inject(AppsService);
  public readonly apps = input.required({ transform: (value: string[]) => this._appsService.getApplicationsSync(value) });
}
